<div *ngIf="loading" class="loading-container flex-content-center">
    <img style="width:150px; " src="https://lmsassetspremium.lntedutech.com/portalicons/loader.gif" />
  </div>
<router-outlet></router-outlet>
